import { render, staticRenderFns } from "./ceBianLang.vue?vue&type=template&id=5872a7d8"
import script from "./ceBianLang.vue?vue&type=script&lang=js"
export * from "./ceBianLang.vue?vue&type=script&lang=js"
import style0 from "./ceBianLang.vue?vue&type=style&index=0&id=5872a7d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports